import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const ApprovalMonitorLegacyRedirectPage = () => {
  const { id } = useParams();

  return <Navigate to={`/approvalmng/monitoring/${id}`} replace />;
};

export default ApprovalMonitorLegacyRedirectPage;
